import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    standalone: false
})
export class VideoComponent {
  @Input() videoSrc = '';
  /*   set videoSrc(value: string) {
    this.safeVideoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(value);
  } */
}
